// pages/Dashboard/Services.js
function Services() {
  return <h2>Services</h2>;
}

export default Services;